import { TPlanCode } from '@/contexts/billingContext/domain/types';

import { EBillingPlanCode } from './constants';

export const getIsCustomCargoOwnerPlanCode = (planCode?: TPlanCode | null): boolean => !!planCode?.startsWith(`${EBillingPlanCode.cargoOwner}.`);
